import { REPORT_NUMBER_TYPES } from 'Components/UI/EAReport/constants'
import moment from 'moment'

const DATE_FORMATS = ['YYYY-MM-DDTHH:mm:ss.SSSZ', 'YYYY-MM-DDTHH:mm:ssZ', 'YYYY-MM-DD']

const formatValueCsv = (value, column, record) => {
  if (value && typeof value === 'string' && moment(value, DATE_FORMATS, true).isValid()) {
    return moment(value).format('DD/MM/YYYY HH:mm:ss')
  }

  if (REPORT_NUMBER_TYPES.includes(column.type)) {
    return record[`${column.dataIndex}_csv`] || value
  }

  return value === null || value === undefined ? '' : value
}

export default formatValueCsv
